export var ABBREVIATED_MONTH_MAP = {
  0: 'Jan',
  1: 'Feb',
  2: 'Mar',
  3: 'Apr',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'Aug',
  8: 'Sep',
  9: 'Oct',
  10: 'Nov',
  11: 'Dec'
};

/**
 * Returns the abbreviated month of a Date
 */
var getAbbreviatedMonth = function getAbbreviatedMonth(date) {
  return ABBREVIATED_MONTH_MAP[date.getMonth()];
};
export default getAbbreviatedMonth;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/utils/dist/esm/date/getAbbreviatedMonth.js
// module id = 1239
// module chunks = 11